// extracted by mini-css-extract-plugin
export default {"capabilityItemWrapper":"styles_capabilityItemWrapper__BukGp","contentWrapper":"styles_contentWrapper__MbhWM"};